import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-655e2ded"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "deprecated-page flex col p24",
  "aria-labelledby": "deprecated-title"
}
const _hoisted_2 = { class: "notice flex col align-center g24 shadow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex col align-center g10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "100",
    src: "/ico/logo.svg",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    width: "140",
    src: "/ico/label.svg",
    alt: "SecurEat"
  })
], -1))
const _hoisted_4 = { id: "deprecated-title" }
const _hoisted_5 = {
  class: "dashboard-link",
  href: "https://dashboard.secureat.io"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.Lang.getI18N("dashboard-deprecated-title")), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.Lang.getI18N("dashboard-deprecated-message")), 1),
      _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.Lang.getI18N("open-new-dashboard")), 1),
      _createElementVNode("button", {
        type: "button",
        class: "logout",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.logout()))
      }, _toDisplayString(_ctx.Lang.getI18N("logout")), 1)
    ])
  ]))
}